import { z } from 'zod';

export const requestPasswordResetSchema = z.object({
  email: z.email('Ingresa un correo electrónico válido.'),
});

export type RequestPasswordResetFormValues = z.infer<typeof requestPasswordResetSchema>;

export const passwordPolicy = z
  .string()
  .min(8, 'La contraseña debe tener mínimo 8 caracteres.')
  .regex(/[A-Z]/, 'La contraseña debe tener al menos una mayúscula.')
  .regex(/[a-z]/, 'La contraseña debe tener al menos una minúscula.')
  .regex(/\d/, 'La contraseña debe tener al menos un número.')
  .regex(/[^A-Za-z0-9]/, 'La contraseña debe tener al menos un carácter especial.');

export const resetPasswordSchema = z
  .object({
    token: z.string().min(1, 'El token es requerido.'),
    newPassword: passwordPolicy,
    confirmPassword: z.string().min(1, 'Confirmar contraseña es requerido.'),
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    message: 'Las contraseñas no coinciden.',
    path: ['confirmPassword'],
  });

export type ResetPasswordFormValues = z.infer<typeof resetPasswordSchema>;
